import React, {Component} from 'react';
import {NavBar} from 'antd-mobile';
import './style.less';

export default class RealName extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    
    componentDidMount() {

    }

    render() {
        return (
            <div className="realName">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}></i>}
                >帮助中心</NavBar>
                <div className="contentBox">
                    <div className="title">关于实名乘车的说明</div>
                    <div className="first">
                        <div>1、根据国家公安部和网约车相关规范要求，乘车人必须实名，确保乘车人身份信息准确；</div>
                        <div>2、为了确保乘客的合法权益，请务必在下单时填写真实有效的乘车人身份信息；</div>
                        <div>3、乘客上车前，驾驶员有权核对乘车人身份信息，发现乘车人信息不一致的，驾驶员有权拒绝乘车人上车，由此导致的损失由乘客自行承担；</div>
                        <div>4、使用虚假身份信息乘车的平台驾驶员有权拒绝乘客乘车并报公安机关。</div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/member/HelpCenter/RealName/index.js